<template>

  <div>
    <div class="works-filter">
      <div class="works-filter__block works-filter__block-list disable">
        <filter-search-sub/>
      </div>

      <filter-arttype-sub label_class="works-filter__labels"/>
      <filter-genre-sub label_class="works-filter__labels"/>
      <filter-style-sub label_class="works-filter__labels"/>
      <filter-technique-sub label_class="works-filter__labels"/>
      <filter-period-sub label_class="works-filter__labels"/>
      <!--<filter-country8/>-->
      <filter-pl-region-sub :title="$t('message.DeliveryPlRegionWorks')"/>
    </div>
  </div>
</template>


<script>
  import WorksFilterMix from "../../../../components/list/WorksFilterMix";
  import WorksComputedMix from "../../../../components/WorksComputedMix";

  import FilterGenreSub from "./filter/FilterGenreSub";
  import FilterStyleSub from "./filter/FilterStyleSub";
  import FilterTechniqueSub from "./filter/FilterTechniqueSub";
  import FilterPeriodSub from "./filter/FilterPeriodSub";
  //import FilterCountry8 from "../../../../components/list/filter/FilterCountry8";
  import FilterArttypeSub from "./filter/FilterArttypeSub";
  import FilterSearchSub from "./filter/FilterSearchSub";
  import FilterPlRegionSub from "./filter/FilterPlRegionSub";

  export default {
    components: {
      FilterPlRegionSub,
      FilterSearchSub,
      FilterArttypeSub,
      FilterGenreSub,
      FilterStyleSub, FilterTechniqueSub, FilterPeriodSub,
      //FilterCountry8,
    },
    name      : 'artists-filtersub',
    mixins: [WorksFilterMix, WorksComputedMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/flat_light/components/list/ArtistsFilterSub.vue